import abstractPeriodReportArchiveSectionWidget from "./abstractPeriodReportArchiveSectionWidget.js";
import CardsStrategy from "../../../core/widgets/list/ListSourceWidget/strategies/CardsStrategy.js";
import PeriodReportArchiveIconWidget from "./PeriodReportArchiveIconWidget.js";

/**
 * `periodReportArchiveIconSectionWidget` is a period report section displaying a list of items as widgets
 *
 * @param {*} spec - Parameter object
 * @param {*} my - protected fields holder
 * @return {{}}
 */
function periodReportArchiveIconSectionWidget(spec, my) {
	spec ||= {};
	my ||= {};

	const that = abstractPeriodReportArchiveSectionWidget(spec, my);

	my.reportRenderer = function (report) {
		const widget = new PeriodReportArchiveIconWidget({
			report,
			selected: my.selectionPredicate(report),
			canSeePeriodReportViewers: spec.canSeePeriodReportViewers,
		});

		widget.onSelect.register(that.onSelect.trigger);

		return widget;
	};

	my.addHooks = function (div) {
		div.click((event) => {
			const clickOnIcon = event.target.classList.contains("fp-icon");
			if (!clickOnIcon) {
				that.onResetSelection.trigger();
			}
		});
	};

	my.getGridClass = function () {
		return CardsStrategy;
	};

	my.getExtraOptions = function () {
		return {
			itemRenderer: function (report) {
				return my.reportRenderer(report);
			},
		};
	};

	return that;
}

export default periodReportArchiveIconSectionWidget;
